import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Addresses_ds_get_contacts_by_accountId_top1Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { accountId: number }): 
  Promise<{ result: { Id?: number, OwnerEntity?: string, OwnerId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.accountId)) {
      $missingRequiredInParams.push('\'accountId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      accountId: number    }) {
        if(isNil($inParams.accountId)) {
          return true; 
        }
      return false;
    }
}
